export default __webpack_public_path__ + "static/media/Foto5-2_Els_Bellem.d6ba4196.jpg";